module.exports = __webpack_public_path__ + "img/2048-haze.f6918007.svg";